import { createRoutine } from 'redux-saga-routines';

export const createCustomObject = createRoutine('CREATE_CUSTOM_OBJECT');

export const updateCustomObject = createRoutine('UPDATE_CUSTOM_OBJECT');

export const fetchCustomObjects = createRoutine('FETCH_CUSTOM_OBJECTS');

export const fetchCustomObjectsLimit = createRoutine(
  'FETCH_CUSTOM_OBJECTS_LIMIT'
);

export const fetchCustomObjectById = createRoutine('FETCH_CUSTOM_OBJECT_BY_ID');

export const pinCustomObject = createRoutine('PIN_CUSTOM_OBJECT');

export const archiveCustomObject = createRoutine('ARCHIVE_CUSTOM_OBJECT');

export const showCustomObjectAddEditForm = createRoutine(
  'SHOW_CUSTOM_OBJECT_ADD_EDIT_FORM'
);

export const createCustomObjectInstance = createRoutine(
  'CREATE_CUSTOM_OBJECT_INSTANCE'
);

export const updateCustomObjectInstance = createRoutine(
  'UPDATE_CUSTOM_OBJECT_INSTANCE'
);

export const fetchCustomObjectInstances = createRoutine(
  'FETCH_CUSTOM_OBJECT_INSTANCES'
);

export const archiveCustomObjectInstance = createRoutine(
  'ARCHIVE_CUSTOM_OBJECT_INSTANCE'
);

export const restoreCustomObjectInstance = createRoutine(
  'RESTORE_CUSTOM_OBJECT_INSTANCE'
);
